import React from 'react';
import PropTypes from 'prop-types';
import AvailableLanguageLink from '../AvailableLanguageLink';
import { Link } from 'src/components/Inputs';

const propTypes = {
  id: PropTypes.string,
  availableLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const DeVersion = ({ id, availableLanguages }) => {
  return (
    <>
      <h4
        id={id || 'datenschutzerklarung'}
        data-magellan-target={id || 'datenschutzerklarung'}
      >
        Alle Personengruppen <br />
        Datenschutzerklärung
      </h4>

      <p>Verfügbare Sprachen:</p>
      <ul>
        {availableLanguages.map((language, i) => {
          return (
            <AvailableLanguageLink
              key={`language-${i}`}
              href={language.href}
              label={language.label}
            />
          );
        })}
      </ul>
      <br />
      <br />

      <p>Gültigkeitsdatum: 22. Februar 2024</p>
      <p>
        Vielen Dank, dass Sie Plaid nutzen! Wir hoffen, dass Sie sich etwas Zeit
        nehmen, um diese Datenschutzerklärung sorgfältig zu lesen.
      </p>
      <p>
        Diese Datenschutzerklärung erläutert die Art und Weise, wie Plaid Inc.
        und seine Tochtergesellschaften, einschließlich Plaid Financial Ltd.
        Plaid Consumer Reporting Agency, Inc. und Plaid, B.V. (zusammen „Plaid“,
        „wir“, „unser“ und „uns“), Daten über Sie (d. h. den Entwickler, Kunden,
        Website-Besucher) erheben, verwenden und weitergeben, wenn Sie die
        Websites von Plaid besuchen oder nutzen, unsere Produkte und
        Dienstleistungen in Ihre Softwareanwendung integrieren oder anderweitig
        mit uns interagieren (z. B. wenn Sie eine Kundendienstanfrage stellen
        oder an einer Plaid-Veranstaltung oder einem Webinar teilnehmen). Die
        vorliegende Datenschutzerklärung gilt nicht für Daten, die wir über
        Endnutzer erfassen, wenn sie ihre Finanzkonten über Plaid mit einer App
        verbinden, bzw. für die Daten, die verwendet werden, um einen Plaid
        CRA-Verbraucherbericht zu erstellen. Wenn Sie mehr darüber erfahren
        möchten, wie wir mit den unter diesen Umständen erhobenen Daten umgehen,
        lesen Sie bitte unsere{' '}
        <Link href='#end-user-services-agreement-ewr-de'>
          <a>Datenschutzerklärung für Endnutzer</a>
        </Link>{' '}
        oder{' '}
        <Link href='https://plaid.com/legal/#end-user-privacy-policy'>
          <a>Datenschutzrichtlinie für Plaid Consumer Reporting Agency</a>
        </Link>
        .
      </p>
      <p>
        <em>Zum Abschnitt springen:</em>
      </p>

      <p>
        <Link href='#unsere-datenpraxis-datenschutzerklarung'>
          <a data-smooth-scroll data-offset='80'>
            Unsere Datenpraxis
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#gesammelte-informationen-und-kategorien-von-datenquellen-datenschutzerklarung'>
              <a data-smooth-scroll data-offset='80'>
                Gesammelte Informationen und Kategorien von Datenquellen
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#wie-wir-ihre-daten-nutzen-datenschutzerklarung'>
              <a>Wie wir Ihre Daten nutzen</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#unsere-rechtsgrundlagen-fur-die-verarbeitung-datenschutzerklarung'>
              <a>
                Unsere Rechtsgrundlagen für die Verarbeitung im EWR und im
                Vereinigten Königreich
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#wie-wir-ihre-daten-weitergeben-datenschutzerklarung'>
              <a>Wie wir Ihre Daten weitergeben</a>
            </Link>
          </p>
        </li>
      </ul>

      <p>
        <Link href='#andere-hinweise-datenschutzerklarung'>
          <a data-smooth-scroll data-offset='80'>
            Andere Hinweise
          </a>
        </Link>
      </p>

      <ul data-smooth-scroll data-offset='80'>
        <li>
          <p>
            <Link href='#chatbots-werbung-analysen-und-sonstige-dienste-von-dritten-datenschutzerklarung'>
              <a>
                Chatbots, Werbung, Analysen und sonstige Dienste von Dritten
              </a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#internationale-datenubermittlung-datenschutzerklarung'>
              <a>Internationale Datenübermittlung</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#datenspeicherung-datenschutzerklarung'>
              <a>Datenspeicherung</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#ihre-wahlmoglichkeiten-datenschutzerklarung'>
              <a>Ihre Wahlmöglichkeiten</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#ihre-datenschutzrechte-datenschutzerklarung'>
              <a>Ihre Datenschutzrechte</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#anderungen-an-dieser-erklärung-datenschutzerklarung'>
              <a>Änderungen an dieser Erklärung</a>
            </Link>
          </p>
        </li>
        <li>
          <p>
            <Link href='#kontaktaufnahme-mit-plaid-datenschutzerklarung'>
              <a>Kontaktaufnahme mit Plaid</a>
            </Link>
          </p>
        </li>
      </ul>
      <br />
      <br />

      <h4 id='unsere-datenpraxis-datenschutzerklarung'>Unsere Datenpraxis</h4>
      <h5 id='gesammelte-informationen-und-kategorien-von-datenquellen-datenschutzerklarung'>
        Gesammelte Informationen und Kategorien von Datenquellen
      </h5>
      <p>
        <strong>Daten, die Sie uns mitteilen</strong>: Wir erheben Daten, die
        Sie Plaid direkt übermitteln. Sie geben beispielsweise personenbezogene
        Daten an, wenn Sie ein Entwicklerkonto erstellen, unser Formular
        „Kontakt“ ausfüllen, sich für unsere E-Mails anmelden, Kundensupport
        anfordern, sich für die Abrechnung anmelden oder anderweitig mit uns
        kommunizieren. Zu den Arten von Daten, die wir erheben, gehören:
      </p>
      <ul>
        <li>
          <p>
            Identifikatoren (wie der vollständige Name, E-Mail-Adresse,
            Postanschrift, Telefonnummer und Geburtsdatum);
          </p>
        </li>
        <li>
          <p>
            sensible Informationen (wie eine Führerscheinnummer und
            Steueridentifikationsnummer, Finanzkontoinformationen und
            Sozialversicherungsnummern, die für die Erbringung von Diensten
            erforderlich sind);
          </p>
        </li>
        <li>
          <p>berufliche Informationen (wie Firmenname und Titel); und</p>
        </li>
        <li>
          <p>
            alle anderen personenbezogenen Daten, die Sie zur Verfügung stellen
            (z. B. in Supportnachrichten für Entwickler).
          </p>
        </li>
      </ul>
      <p>
        Wir können auch bestimmte Unterlagen mit Ihrem Foto erheben oder Sie
        auffordern, Ihre Identität durch ein Foto oder ein Video von sich selbst
        zu bestätigen. Daten, die in diesem Zusammenhang erhoben werden, können
        in einigen Staaten oder Ländern als biometrische Daten angesehen werden,
        wie unten angegeben. Siehe den besonderen Hinweis für Einwohner von
        Illinois und Texas unten.
      </p>
      <p>
        <u>
          Besonderer Hinweis zu biometrischen Daten für Einwohner von Illinois
          und Texas
        </u>
      </p>
      <p>
        Für Einwohner von Illinois oder Texas gilt: Wenn wir von Ihnen die
        Vorlage eines Dokuments verlangen, das ein Foto von Ihnen enthält, oder
        wenn Sie Ihre Identität anhand eines Fotos oder eines Videos von sich
        selbst bestätigen müssen, können die von Ihrem Gesicht abgeleiteten
        Daten, die wir und unsere Dienstleister in unserem Namen erheben und
        verarbeiten, an einigen Orten als biometrische Daten gelten. Ihre Daten
        werden nicht länger als drei Jahre gespeichert, es sei denn, dies ist
        gesetzlich vorgeschrieben.
      </p>
      <p>
        <strong>
          Daten, die wir erhalten, wenn Sie unsere Technologie testen
        </strong>
        : Manchmal verwenden Personen, die Anwendungen mit unseren Diensten
        erstellen, ihre eigenen Anmeldedaten für ihr Bankkonto oder ein anderes
        Finanzkonto, um zu testen und zu bewerten, wie unsere Technologie in
        ihrer Anwendung erscheint und funktioniert. Wenn Sie dies tun, sollten
        Sie unsere{' '}
        <Link href='#end-user-services-agreement-ewr-de'>
          <a>Datenschutzerklärung für Endnutzer</a>
        </Link>{' '}
        lesen, um zu erfahren, wie wir diese Daten erheben und handhaben.
      </p>
      <p>
        <strong>Daten, die wir erheben, wenn Sie unsere Dienste nutzen</strong>:
        Wenn Sie unsere Dienste nutzen, werden die folgenden Daten über Sie
        erhoben:
      </p>
      <ul>
        <li>
          <p>
            <strong>Protokolldaten</strong>: Wir erheben Protokolldateien, wenn
            Sie unsere Dienste nutzen. Dazu gehören Identifikatoren und
            Informationen über die elektronische Netzwerkaktivität, wie der von
            Ihnen verwendete Browsertyp, der Zeitpunkt Ihres Zugriffs auf unsere
            Dienste, die aufgerufenen Seiten und Ihre IP-Adresse.
          </p>
        </li>
        <li>
          <p>
            <strong>Ungefährer Standort</strong>: Wir bestimmen den ungefähren
            Standort des Geräts, mit dem Sie auf unsere Dienste zugreifen,
            anhand Ihrer IP-Adresse oder der Zeitzoneneinstellung Ihres Geräts.
          </p>
        </li>
        <li>
          <p>
            <strong>
              Durch Cookies und andere Tracking-Technologien erhobene Daten
            </strong>
            : Wir verwenden verschiedene Technologien wie Cookies und Web
            Beacons in unseren Diensten, um personenbezogene Daten zu erheben.
            Cookies sind kleine Datendateien, die über Ihren Webbrowser, auf
            Ihrer Festplatte oder im Speicher Ihres Geräts gespeichert werden
            und die es uns ermöglichen, unsere Dienste und Ihre Erfahrungen zu
            verbessern, die Nutzung unserer Dienste zu ermitteln und potenziell
            schädliches Verhalten zu überwachen und zu erkennen. Web Beacons
            sind elektronische Bilder, die in unseren Diensten oder E-Mails
            eingesetzt werden und uns dabei helfen, Cookies zu versenden. Web
            Beacons zählen, wie oft eine Webseite besucht wird, und helfen uns
            zu verstehen, wie unser Dienst genutzt wird, und ihn zu verbessern.
          </p>
          <ul>
            <li>
              <p>
                Bitte beachten Sie, dass wir Cookies von Drittanbietern für
                unsere Werbezwecke verwenden können, soweit dies gesetzlich
                zulässig ist und wie in unserer{' '}
                <Link href='#cookie-richtlinie'>
                  <a>Cookie-Richtlinie</a>
                </Link>{' '}
                näher erläutert. Um Ihre Cookie-Einstellungen und -Präferenzen
                zu ändern, einschließlich derer für Targeting- und
                Werbe-Cookies, klicken Sie auf den Link „Cookie-Einstellungen“
                in der Fußzeile der Seite.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>Daten, die wir aus anderen Quellen erheben</strong>: Wir erheben
        auch Daten über Sie aus anderen Quellen ein. So können wir
        beispielsweise Daten von anderen Mitarbeitern Ihres Unternehmens und von
        Anbietern erheben, die uns dabei helfen, neue Geschäftskunden zu
        identifizieren, und zwar einschließlich Ihres Namens, Ihrer
        E-Mail-Adresse und der URL Ihres Profils in sozialen Medien.
      </p>

      <h5 id='wie-wir-ihre-daten-nutzen-datenschutzerklarung'>
        Wie wir Ihre Daten nutzen
      </h5>
      <p>
        Wir verwenden die erhobenen Daten für die folgenden geschäftlichen und
        wirtschaftlichen Zwecke:
      </p>
      <ul>
        <li>
          <p>
            um unsere Dienste zu betreiben, zu verbessern und zu entwickeln;
          </p>
        </li>
        <li>
          <p>um Ihre Identität zu überprüfen;</p>
        </li>
        <li>
          <p>
            um Entwicklern unsere Dienste in Rechnung zu stellen und um sie zu
            bezahlen;
          </p>
        </li>
        <li>
          <p>zur Einhaltung von Gesetzen, z. B. für Steuerzwecke;</p>
        </li>
        <li>
          <p>
            um Ihnen Dinge wie technische Hinweise, Updates,
            Sicherheitswarnungen und Nachrichten über Ihr Konto zu senden;
          </p>
        </li>
        <li>
          <p>
            um Ihre Anmerkungen, Fragen, Anfragen und Kundendienstanfragen zu
            beantworten;
          </p>
        </li>
        <li>
          <p>um die Dienste für Sie zu persönlicher zu gestalten;</p>
        </li>
        <li>
          <p>
            um mit Ihnen über Produkte, Dienste, Angebote und
            Plaid-Veranstaltungen zu kommunizieren, die wir anbieten oder
            sponsern;
          </p>
        </li>
        <li>
          <p>
            um Trends, Nutzung und Aktivitäten im Zusammenhang mit unseren
            Diensten zu überwachen und zu analysieren;
          </p>
        </li>
        <li>
          <p>
            um Betrug, böswillige Aktivitäten und andere illegale Aktivitäten
            aufzudecken und zu verhindern;
          </p>
        </li>
        <li>
          <p>
            um die Rechte, die Privatsphäre, die Sicherheit oder das Eigentum
            von Plaid und anderen zu schützen; und
          </p>
        </li>
        <li>
          <p>
            für andere Zwecke, über die wir Sie vor oder zum Zeitpunkt der
            Erhebung der Daten informieren.
          </p>
        </li>
      </ul>

      <h5 id='unsere-rechtsgrundlagen-fur-die-verarbeitung-datenschutzerklarung'>
        Unsere Rechtsgrundlagen für die Verarbeitung im EWR und im Vereinigten
        Königreich
      </h5>
      <p>
        Plaid verarbeitet Ihre personenbezogenen Daten nur, wenn wir eine
        gültige Rechtsgrundlage dafür haben. Unsere Rechtsgrundlage für die
        Verarbeitung der von uns erhobenen Daten hängt davon ab, welche Daten
        wir erhoben haben und in welchem Kontext wir sie verarbeiten.
        Grundsätzlich gilt, dass wir Daten nur dann erheben und verarbeiten,
        wenn:
      </p>
      <ul>
        <li>
          <p>
            wir unsere Verantwortung und Verpflichtungen aus einem Vertrag oder
            einer Vereinbarung mit Ihnen erfüllen müssen;
          </p>
        </li>
        <li>
          <p>
            wir unseren gesetzlichen Verpflichtungen nach dem anwendbaren Recht
            nachkommen müssen;
          </p>
        </li>
        <li>
          <p>
            die Verarbeitung zur Wahrung unserer berechtigten Interessen
            erforderlich ist und Ihre Datenschutzinteressen oder Grundrechte und
            -freiheiten nicht überwiegen (z. B. zur Bereitstellung oder
            Aktualisierung unserer Dienste) und
          </p>
        </li>
        <li>
          <p>Sie Ihre Einwilligung dazu gegeben haben.</p>
        </li>
      </ul>

      <h5 id='wie-wir-ihre-daten-weitergeben-datenschutzerklarung'>
        Wie wir Ihre Daten weitergeben
      </h5>
      <p>Wir geben Daten über Sie wie folgt weiter:</p>
      <ul>
        <li>
          <p>
            An andere Unternehmen oder natürliche Personen wie Dienstleister,
            Auftragnehmer oder Geschäftspartner, die Dienstleistungen für uns
            erbringen und uns bei unserem Geschäft unterstützen. Wir geben auch
            Daten an Inkassobüros weiter, wenn unsere Entwickler mit Zahlungen
            im Rückstand sind.
          </p>
        </li>
        <li>
          <p>
            Wenn wir in gutem Glauben davon überzeugt sind, dass die Offenlegung
            angemessen ist, um anwendbare Gesetze, Vorschriften oder rechtliche
            Verfahren (wie Gerichtsbeschlüsse oder Vorladungen) zu erfüllen.
            Dies schließt die Offenlegung im Zusammenhang mit Anfragen von
            Strafverfolgungs- oder anderen Regierungsbehörden ein.
          </p>
        </li>
        <li>
          <p>
            Wenn wir der Meinung sind, dass Ihre Handlungen mit unseren
            Vereinbarungen oder Richtlinien unvereinbar sind, oder um die
            Rechte, die Privatsphäre, die Sicherheit oder das Eigentum von Plaid
            oder Dritter zu schützen.
          </p>
        </li>
        <li>
          <p>
            Im Falle einer Änderung der Eigentums- oder
            Beherrschungsverhältnisse in Bezug auf unser gesamtes oder einen
            Teil unseres Unternehmens (z. B. Fusion, Übernahme, Reorganisation
            oder Konkurs).
          </p>
        </li>
        <li>
          <p>
            Zwischen Plaid und unseren derzeitigen und zukünftigen
            Muttergesellschaften, verbundenen Unternehmen, Tochtergesellschaften
            und andere Unternehmen, die unter gemeinsamer Kontrolle oder in
            gemeinsamem Eigentum stehen, und
          </p>
        </li>
        <li>
          <p>mit Ihrer Zustimmung oder auf Ihre Weisung.</p>
        </li>
      </ul>
      <p>
        Wir erheben, verwenden und teilen auch Daten, die aggregiert und
        anonymisiert wurden, sodass sie nicht verwendet werden können, um Sie zu
        identifizieren, für jeden nach geltendem Recht zulässigen Zweck.
      </p>
      <p>
        Wir können personenbezogene Daten an Dritte weitergeben oder ihnen
        erlauben, personenbezogene Daten von unseren Websites oder
        Dienstleistungen zu erheben, wie oben beschrieben.
      </p>
      <p>
        In dieser Tabelle wird erläutert, wie wir in den letzten zwölf Monaten
        personenbezogene Daten erheben und weitergegeben haben.
      </p>
      <br />

      <p>KATEGORIEN VON PERSONENBEZOGENEN DATEN</p>
      <div className='all-audiences-container'>
        <table className='all-audiences-table'>
          <thead>
            <tr>
              <td colSpan='1' rowSpan='1'>
                <p>
                  <span>Kategorie der personenbezogenen Daten</span>
                </p>
              </td>
              <td colSpan='1' rowSpan='1'>
                <p>
                  <span>Quelle der personen-bezogenen Daten</span>
                </p>
              </td>
              <td colSpan='1' rowSpan='1'>
                <p>
                  <span>
                    Verwendung personenbezogener Daten (weitere Einzelheiten zu
                    den unten genannten Anwendungsfällen finden Sie oben)
                  </span>
                </p>
              </td>
              <td colSpan='1' rowSpan='1'>
                <p>
                  <span>
                    Kategorien von Parteien, an die personenbezogene Daten
                    weitergegeben werden können
                  </span>
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <span>Identifikatoren</span>
                  </li>
                  <li>
                    <span>Finanzielle Daten</span>
                  </li>
                  <li>
                    <span>Wirtschaftliche Daten</span>
                  </li>
                  <li>
                    <span>Standortdaten</span>
                  </li>
                  <li>
                    <span>Berufliche Informationen</span>
                  </li>
                  <li>
                    <span>
                      Informationen über elektronische Netzwerkaktivität
                    </span>
                  </li>
                  <li>
                    <span>Sensible Informationen</span>
                  </li>
                  <li>
                    <span>Schlussfolgerungen</span>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <span>Daten, die Sie uns mitteilen</span>
                  </li>
                  <li>
                    <span>
                      Informationen, die wir von Ihren Geräten erhalten
                    </span>
                  </li>
                  <li>
                    <span>
                      Informationen, die wir aus anderen Quellen über Sie
                      erhalten, wie oben beschrieben.
                    </span>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <span>Bereitstellung von Diensten</span>
                  </li>
                  <li>
                    <span>Betrugsvermeidung und Datenschutz</span>
                  </li>
                  <li>
                    <span>Bereitstellung von Support</span>
                  </li>
                  <li>
                    <span>Ermittlung von Missbrauch und Verstößen</span>
                  </li>
                  <li>
                    <span>Erfüllung gesetzlicher Verpflichtungen</span>
                  </li>
                  <li>
                    <span>Mit Ihrer Zustimmung</span>
                  </li>
                </ul>
              </td>
              <td colSpan='1' rowSpan='1'>
                <ul>
                  <li>
                    <span>
                      Dienstleister, die Plaid bei der Analyse von Daten für
                      Geschäftszwecke unterstützen
                    </span>
                  </li>
                  <li>
                    <span>Anbieter von Nutzerforschung und Umfragen</span>
                  </li>
                  <li>
                    <span>
                      Anbieter von Tools für die interne Zusammenarbeit und
                      Kommunikation
                    </span>
                  </li>
                  <li>
                    <span>Anbieter von E-Mail-Diensten</span>
                  </li>
                  <li>
                    <span>
                      Anbieter von Kundenbeziehungsmanagement sowie Vertriebs-
                      und Marketingunterstützung
                    </span>
                  </li>
                  <li>
                    <span>
                      Anbieter von Veranstaltungsmanagement und Hosting
                    </span>
                  </li>
                  <li>
                    <span>Anbieter von Kundensupportdiensten</span>
                  </li>
                  <li>
                    <span>Anbieter von Lead-Generierung</span>
                  </li>
                  <li>
                    <span>Anbieter von Dokumentenmanagement-Diensten</span>
                  </li>
                  <li>
                    <span>
                      Anbieter von Cloud-Speicher und Data Warehousing
                    </span>
                  </li>
                  <li>
                    <span>Zahlungsdienstleister</span>
                  </li>
                  <li>
                    <span>
                      Anbieter von Diensten zur Betrugsprävention,
                      Identitätsüberprüfung und Sicherheit
                    </span>
                  </li>
                  <li>
                    <span>Anbieter von Softwareentwicklungsdiensten</span>
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h4 id='andere-hinweise-datenschutzerklarung'>Andere Hinweise</h4>
      <h5 id='chatbots-werbung-analysen-und-sonstige-dienste-von-dritten-datenschutzerklarung'>
        Chatbots, Werbung, Analysen und sonstige Dienste von Dritten
      </h5>
      <p>
        Wir gestatten Dritten, einschließlich Google Analytics, Analysen zu
        erstellen und Werbung auf unseren Websites zu schalten. Diese Dritten
        verwenden Cookies, Web-Beacons und andere Technologien, um Daten über
        Sie zu erheben. Plaid verwendet Chatbots, die von Drittanbietern
        betrieben werden. Bitte beachten Sie, dass Ihre Daten zum Betrieb des
        Chatbots an den Drittanbieter weitergegeben werden können, wenn Sie
        unserem Chatbot personenbezogene Daten zur Verfügung stellen.
      </p>
      <p>
        Nähere Informationen darüber, wie wir Cookies verwenden und welche
        Möglichkeiten Sie haben, finden Sie in unserer{' '}
        <Link href='#cookie-richtlinie'>
          <a>Cookie-Richtlinie</a>
        </Link>
        .
      </p>

      <h5 id='internationale-datenubermittlung-datenschutzerklarung'>
        Internationale Datenübermittlung
      </h5>
      <p>
        Wir können die Daten, die wir über Sie erheben, zur Verarbeitung und
        Speicherung in andere Länder als das Land, in dem Sie leben, übertragen.
        Wenn wir Daten in ein Land oder Gebiet übertragen, das nicht über
        gleichwertige Datenschutzgesetze wie Ihr Land verfügt, werden wir diese
        Daten in Übereinstimmung mit den geltenden Datenschutzgesetzen
        übertragen. Insbesondere können wir von der EU-Kommission oder vom
        britischen Außenministerium genehmigte (je nach Fall)
        Standardvertragsklauseln verwenden, gegebenenfalls in Kombination mit
        zusätzlichen Sicherheitsvorkehrungen. Sie können eine Kopie dieser
        Standardvertragsklauseln anfordern, wenn Sie uns wie unten beschrieben
        kontaktieren.
      </p>
      <h5 id='datenspeicherung-datenschutzerklarung'>Datenspeicherung</h5>
      <p>
        Wir bewahren Ihre personenbezogenen Daten nicht länger auf, als es für
        die Erreichung der Zwecke, für die sie erhoben wurden, erforderlich ist,
        es sei denn, das geltende Recht schreibt eine längere Aufbewahrungsfrist
        vor.
      </p>

      <h5 id='ihre-wahlmoglichkeiten-datenschutzerklarung'>
        Ihre Wahlmöglichkeiten
      </h5>
      <ul>
        <li>
          <p>
            <strong>Informationen zum Entwicklerkonto</strong>: Sie können die
            Informationen, die Sie uns im Rahmen Ihres Online-Entwicklerkontos
            bereitstellen, aktualisieren, indem Sie sich in Ihrem Konto anmelden
            oder sich mit uns in Verbindung setzen.
          </p>
        </li>
        <li>
          <p>
            <strong>Cookies</strong>: Nähere Informationen darüber, wie wir
            Cookies verwenden und welche Möglichkeiten Sie haben, finden Sie in
            unserer{' '}
            <Link href='#cookie-richtlinie'>
              <a>Cookie-Richtlinie</a>
            </Link>
            .
          </p>
        </li>
        <li>
          <p>
            <strong>Marketing-Kommunikationen</strong>: Sie haben die
            Möglichkeit, den Erhalt von Marketing-E-Mails von Plaid anzunehmen
            oder abzulehnen, indem Sie die Anweisungen in diesen E-Mails
            befolgen. Wenn Sie sich dagegen entscheiden, können wir Ihnen
            weiterhin andere Arten von E-Mails senden, z. B. Support-, Service-
            und andere E-Mails über Ihr Konto oder unsere laufende
            Geschäftsbeziehung.
          </p>
        </li>
      </ul>

      <h5 id='ihre-datenschutzrechte-datenschutzerklarung'>
        Ihre Datenschutzrechte
      </h5>
      <p>
        Sie haben möglicherweise Rechte in Bezug auf Ihre personenbezogenen
        Daten, einschließlich des Rechts, zu erfahren, wie wir Ihre Daten
        erheben, verwenden oder weitergeben. Darüber hinaus haben Sie
        möglicherweise das Recht, Zugang zu Ihren personenbezogenen Daten zu
        verlangen sowie zu versuchen, diese Daten zu aktualisieren, zu löschen
        oder zu korrigieren. Wir werden Ihrer Anfrage zur Ausübung dieser Rechte
        unabhängig von Ihrem Standort nachkommen. Sie werden nicht
        diskriminiert, wenn Sie diese Rechte wahrnehmen.
      </p>
      <p>
        In bestimmten Regionen, einschließlich des EWR und des Vereinigten
        Königreichs, stehen Ihnen möglicherweise zusätzliche Rechte zur
        Verfügung. Zu diesen Rechten gehört das Recht, der Verarbeitung Ihrer
        personenbezogenen Daten zu widersprechen oder zu verlangen, dass wir
        diese einschränken; die Einwilligung jederzeit zu widerrufen, wenn
        unsere Verarbeitung auf Ihrer Einwilligung basiert; und eine Beschwerde
        bei Ihrer lokalen Aufsichtsbehörde einzureichen (wenn Sie sich im EWR
        befinden, besuchen Sie bitte{' '}
        <Link href='https://edpb.europa.eu/about-edpb/board/members_nl'>
          <a>https://edpb.europa.eu/about-edpb/board/members_nl</a>
        </Link>
        , und wenn Sie sich im Vereinigten Königreich befinden, besuchen Sie
        bitte{' '}
        <Link href='https://ico.org.uk/'>
          <a>www.ico.org.uk</a>
        </Link>{' '}
        für Kontaktdaten).
      </p>
      <p>
        Sowohl für die Plaid Financial Ltd. als auch für die Plaid, B.V. haben
        wir einen Datenschutzbeauftragten (DSB) ernannt, der auch für die
        Beantwortung von Fragen im Zusammenhang mit dieser Datenschutzerklärung
        zuständig ist und per E-Mail unter{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        kontaktiert werden kann.
      </p>
      <p>
        Wenn Sie in Kalifornien ansässig sind, können Ihnen gemäß dem California
        Consumer Protection Act („CCPA“), wie durch den California Privacy
        Rights Act abgeändert, einige zusätzliche Rechte zur Verfügung stehen,
        vorbehaltlich der gesetzlich vorgesehenen Beschränkungen und Ausnahmen.
        Sie können auch Zugriff auf die Kategorien und spezifischen Teile der
        personenbezogenen Daten verlangen, die in den letzten zwölf Monaten über
        Sie erhoben wurden (einschließlich der personenbezogenen Daten, die für
        geschäftliche Zwecke weitergegeben wurden); Sie können erfahren, ob und
        an wen Ihre personenbezogenen Daten „verkauft“ oder „weitergegeben“
        wurden; Sie können den „Verkauf“ oder die „Weitergabe“ Ihrer
        personenbezogenen Daten ablehnen, wenn ein Unternehmen Ihre Daten
        „verkauft“ oder „weitergibt“; und Sie können ein Unternehmen auffordern,
        ungenaue personenbezogene Daten zu korrigieren. Bitte beachten Sie, dass
        wir Ihre personenbezogenen Daten zwar nicht verkaufen, aber an Dritte
        für Werbezwecke anhand von „Cookies“ weitergeben können, wie in unserer
        Cookie-Richtlinie beschrieben.
      </p>
      <p>
        Wie oben unter „Ihre Wahlmöglichkeiten“ beschrieben, können Sie, wenn
        Sie einer unserer Entwickler sind, bequem auf Ihre
        Online-Kontoinformationen zugreifen, indem Sie sich bei Ihrem Konto
        anmelden oder uns kontaktieren. Um Ihre Datenschutzrechte anderweitig
        auszuüben, kontaktieren Sie uns bitte, wie unten im Abschnitt
        „Kontaktaufnahme mit Plaid“ beschrieben. Es kann sein, dass Sie uns
        zusätzliche Informationen geben müssen, um Ihre Identität zu bestätigen,
        bevor wir auf Ihren Antrag antworten können.
      </p>
      <p>
        Wenn wir Ihren Antrag von einem Beauftragten erhalten, können wir den
        Nachweis verlangen, dass Sie diesem Beauftragten eine schriftliche
        Vollmacht erteilt haben, um Anträge in Ihrem Namen zu stellen. Wenn Sie
        ein bevollmächtigter Vertreter sind und einen Antrag stellen möchten,
        setzen Sie sich bitte mit uns in Verbindung, wie unten im Abschnitt
        „Kontaktaufnahme mit Plaid“ beschrieben.
      </p>

      <h5 id='anderungen-an-dieser-erklärung-datenschutzerklarung'>
        Änderungen an dieser Erklärung
      </h5>
      <p>
        Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren
        oder ändern. Wenn wir Aktualisierungen oder Änderungen vornehmen, werden
        wir das Gültigkeitsdatum oben in dieser Erklärung ändern. Wir können Sie
        auch auf andere Weise über Änderungen informieren, z. B. durch einen
        Hinweis auf unserer Homepage{' '}
        <Link href='https://plaid.com'>
          <a>https://plaid.com</a>
        </Link>{' '}
        oder durch eine E-Mail an Sie. Wir empfehlen Ihnen, die
        Datenschutzerklärung jedes Mal durchzusehen, wenn Sie auf die Dienste
        zugreifen oder anderweitig mit uns interagieren, um über unsere
        Datenpraktiken und die Ihnen zur Verfügung stehenden Wahlmöglichkeiten
        informiert zu bleiben.
      </p>

      <h5 id='kontaktaufnahme-mit-plaid-datenschutzerklarung'>
        Kontaktaufnahme mit Plaid
      </h5>
      <p>
        Wenn Sie Fragen zu dieser Datenschutzerklärung oder allgemein zu unseren
        Datenschutzpraktiken haben, schicken Sie uns bitte eine E-Mail an{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        oder einen Brief an:
      </p>
      <p>
        <em>
          Wenn Sie Ihren Wohnsitz außerhalb des EWR oder des Vereinigten
          Königreichs haben:
        </em>
      </p>
      <div className='ios-legal-address'>
        Plaid Inc. <br />
        Attn: Legal <br />
        PO Box 7775 #35278 <br />
        San Francisco, Kalifornien 94120-7775, U.S.A.
      </div>
      <br />
      <p>
        Sowohl für die Plaid Financial Ltd. als auch für die Plaid, B.V. haben
        wir einen Datenschutzbeauftragten (DSB) ernannt, der auch für die
        Beantwortung von Fragen im Zusammenhang mit dieser Datenschutzerklärung
        zuständig ist und per E-Mail unter{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        kontaktiert werden kann.
      </p>
      <p>
        <br />
        <em>Wenn Sie Ihren Wohnsitz im Vereinigten Königreich haben:</em>
      </p>
      <div className='ios-legal-address'>
        Plaid Financial Ltd. <br />
        Attn: Legal <br />
        New Penderel House, 4th Floor <br />
        283-288 High Holborn <br />
        London, Vereinigtes Königreich, WC1V 7HP
      </div>
      <p>
        <br />
        <em>Wenn Sie Ihren Wohnsitz im EWR haben:</em>
      </p>
      <div className='ios-legal-address'>
        Plaid B.V. <br />
        Attn: Legal <br />
        Muiderstraat 1 <br />
        1011PZ Amsterdam
        <br />
        Niederlande
      </div>

      <hr className='section-divider' />
    </>
  );
};

DeVersion.propTypes = propTypes;
export default DeVersion;
